import React  from 'react';
import Typography from '@mui/material/Typography';
import styled from '@mui/system/styled';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import useMediaQuery from '@mui/material/useMediaQuery';
import theme from '@/mui/theme';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {getIconComponentByName} from '@/utils/icons-map';
import { sanitize } from '@/utils/miscellaneous';
import { stripEmbeddedCSV } from '@/utils/embedded-csv';
import ProductDetailCSVTable from '@/components/fasce/ProductDetailCSVTable';

interface ProductDetailDescProps {
  mobileIcon: string;
  title?: string;
  desc?: string;
};

const StyledTitle = styled(Typography)({
  [theme.breakpoints.up('sm')]: {
    fontSize: '24px',
    letterSpacing: '-0.1px',
    lineHeight: '30px',
  },
  color: '#182641',
  fontSize: '16px',
  fontWeight: '800',
  letterSpacing: '0.1px',
  lineHeight: '24px',
});

const StyledDesc = styled(Typography)({
  [theme.breakpoints.up('sm')]: {
    columnCount: '2',
    columnGap: '30px',
    fontSize: '15px',
    lineHeight: '24px',
    letterSpacing: '-0.2px',
  },
  color: '#545454',
  fontSize: '13px',
  lineHeight: '18px',
  letterSpacing: '0',
});

const StyledDivider = styled(Divider)({
  borderColor: '#606060',
});

const StyledAccordion = styled(Accordion)({
  backgroundColor: '#f1f1f1',
  border: '0',
  boxShadow: 'unset',
});

const StyledAccordionSummary = styled(AccordionSummary)({
  "&.Mui-expanded .Mui-expanded": {
    transform: "rotate(0deg)",
  }
});

const ProductDetailDesc: React.FC<ProductDetailDescProps> = ({ title, desc, mobileIcon }) => {
  const matches = useMediaQuery('(min-width:600px)');
  const strippedDesc = stripEmbeddedCSV(desc);
  return (
    <Container fixed sx={{ position: 'relative', zIndex: '20', backgroundColor: 'transparent', paddingTop: { sm: 4.2, xs: 6.625 }, paddingBottom: { sm: 4, xs: '3px' } }}>
      {matches && <>
        <Grid container rowSpacing={0} sx={{ position: 'relative', padding: { sm: 0, xs: '0 16px' } }}>
          <Grid item xs={12}>
            <StyledDivider />
          </Grid>
          {title &&
            <Grid item xs={7}>
              <StyledTitle sx={{ mb: 1.5, mt: 4.5}}>{title}</StyledTitle>
            </Grid>
          }
          {strippedDesc &&
            <Grid item xs={12}>
              <StyledDesc sx={{ mb: 0 }} dangerouslySetInnerHTML={{__html: sanitize(strippedDesc)}} />
            </Grid>
          }
        </Grid>

        <ProductDetailCSVTable description={desc}></ProductDetailCSVTable>
      </>}
      {!matches &&
        <StyledAccordion
          square={true}
          disableGutters={true}
        >
          {title && mobileIcon &&
            <StyledAccordionSummary
              expandIcon={getIconComponentByName(mobileIcon)}
            >
              <StyledTitle>{title}</StyledTitle>
            </StyledAccordionSummary>
          }
          {strippedDesc &&
            <AccordionDetails>
              <StyledDesc sx={{ mb: 0 }} dangerouslySetInnerHTML={{__html: sanitize(strippedDesc)}} />

              <ProductDetailCSVTable description={desc}></ProductDetailCSVTable>
              {/* <ProductDetailCSVTable description={data?.product?.longDescription} /> */}
            </AccordionDetails>
          }
        </StyledAccordion>
      }
    </Container>
  )
}

export default ProductDetailDesc;
